<template>
  <div>
    <div class="doc-intro">
      <p style="font-size: 22px; margin: 0px">🍭自动化易班考试平台🍭</p>
      <div class="content">
        <p>
          本平台可为<strong>易班</strong>内所有进行中的课群考试进行自动化考试服务。
        </p>
        <p>
          平台内置上千万易班题库数据，提交自动考试请求后，后台自动从数据库中匹配正确的答案进行答题，正确率高达<span
            style="color: #d02222; font-weight: 900"
            >99%</span
          >。
        </p>
        <Divider />
        <div class="dialog dialogQuestion">
          <img src="me.jpg" alt="" />
          <div class="dialogBox">平台代考会有被查的风险吗？</div>
        </div>
        <div class="dialog dialogAnswer">
          <img src="portrait.jpeg" alt="" />
          <div class="dialogBox">
            ✅
            系统自动在题库中搜索题目进行答题，再由机器模拟操作，与真人行为如出一辙，完全不会被查风险。<br />
            ✅
            经过自行创建考试测试，使用平台代考后台显示的答题数据与真人答题没有任何差别。
          </div>
        </div>
        <div class="dialog dialogQuestion">
          <img src="me.jpg" alt="" />
          <div class="dialogBox">平台的收费标准是怎么样滴？</div>
        </div>
        <div class="dialog dialogAnswer">
          <img src="portrait.jpeg" alt="" />
          <div class="dialogBox">
            📖 平台上线不久，以价格实惠为主<br />
            💰 代考的价格 = 你需要考试的考试题目数量 * 0.08元<br />
            🌰 例你的考试有100道题，那么你的代考价格就是8元
          </div>
        </div>
        <div class="dialog dialogQuestion">
          <img src="me.jpg" alt="" />
          <div class="dialogBox">
            我有许多朋友同学也需要考试，我帮他们考能赚额外提成吗？
          </div>
        </div>
        <div class="dialog dialogAnswer">
          <img src="portrait.jpeg" alt="" />
          <div class="dialogBox">
            代理朋友同学考试，一方面提高价格帮忙考试赚差价。<br />
            😍 另一方面平台还有相对应的提成政策，详细在主页添加客服微信详谈。
          </div>
        </div>
      </div>
      <Divider />
      <div style="padding: 0 21px; margin-bottom: 30px">
        <Button
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          round
          block
          url="/vedio.mp4"
          >观看教学视频</Button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { Divider, Button } from "vant";
// 写入缓存
localStorage.setItem("intro", true);
</script>

<style scoped>
.doc-intro {
  text-align: center;
  margin-top: 40px;
}
.content {
  margin-top: 15px;
  padding: 0 30px;
  text-align: left;
  text-indent: 20px;
}
.content > p {
  margin: 0;
}

.dialog {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
  position: relative;
}
.dialog > img {
  width: 36px;
  top: 0;
  border: 1px solid #acacac8a;
  border-radius: 50%;
}
.dialogAnswer > img {
  float: left;
  right: 0;
}
.dialogQuestion > img {
  float: right;
  left: 0;
}
.dialog > .dialogBox {
  position: relative;
  line-height: 25px;
  text-indent: 5px;
  border-radius: 4px;
  max-width: 72%;
  margin-bottom: 10px;
  padding: 7px;
}
.dialogQuestion > .dialogBox {
  background: #ffffff;
  color: #071425;
  box-shadow: -2px 2px 9px 0px #0000001a;
  float: right;
  margin-right: 16px;
}
.dialogAnswer > .dialogBox {
  background: #071425;
  color: #ffffff;
  box-shadow: 2px 2px 9px 0px #0000001a;
  float: left;
  margin-left: 16px;
}
.dialog > .dialogBox::before {
  position: absolute;
  content: "";
  border: 8px solid;
}
.dialogQuestion > .dialogBox::before {
  border-color: transparent transparent transparent #ffffff;

  right: -16px;
  top: 8px;
}

.dialogAnswer > .dialogBox::before {
  border-color: transparent #071425 transparent transparent;
  left: -16px;
  top: 11px;
}
</style>
